export const DC_IMPORT_SAVE_CONFIG_LIST = 'DC_IMPORT_SAVE_CONFIG_LIST';
export const DC_SET_ANALYSIS_RESULT = 'DC_SET_ANALYSIS_RESULT';
export const DC_SET_FILE_CONFIRMED_OK = 'DC_SET_FILE_CONFIRMED_OK';
export const DC_IMPORT_SUBMITTING = 'DC_IMPORT_SUBMITTING';
export const DC_IMPORT_QUEUE_ERROR = 'DC_IMPORT_QUEUE_ERROR';
export const DC_IMPORT_QUEUE_SUCCESS = 'DC_IMPORT_QUEUE_SUCCESS';
export const DC_IMPORT_CLEAR_QUEUE_ERROR = 'DC_IMPORT_CLEAR_QUEUE_ERROR';
export const DC_IMPORT_SAVE_UNMATCHED_COUNT = 'DC_IMPORT_SAVE_INMATCHED_COUNT';



// WEBPACK FOOTER //
// ./src/pages/dcimport/state/hub/types.js